import { useWSModal } from "@wingspanhq/fe-component-library";
import { DeleteConfirmation } from "./index";

export const useModalDeleteConfirmation = () =>
  useWSModal(DeleteConfirmation, {
    title: "Are you sure you want to remove this team member?",
    size: "S"
  });
